/**
 * HeroIdentity — BLOCK 01 · 히어로 (회사 정체성 직격)
 * 모든 문구는 copy.js(HERO)에서 가져옴. 기존 B2C 히어로(CustomerHero)는 보존, 홈 조합에서만 강등.
 */
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import styles from '../../styles/HeroIdentity.module.css';
import { HERO } from './copy';
// 실제 배경 이미지 로딩(Vite import). copy.js HERO.bgImage는 기록용 문자열.
import heroBg from '../../assets/images/hero-action.jpg';

export default function HeroIdentity() {
  const [ref, isVisible] = useScrollAnimation({ once: true });

  return (
    <section id="hero" ref={ref} className={`${styles.hero} ${isVisible ? styles.visible : ''}`}>
      {/* 배경: 실제 대회 사진(hero-action). 인라인 style로 Vite import 값을 주입, .overlay가 가독성 보정 */}
      <div className={styles.bg} aria-hidden="true" data-slot={HERO.bgImage} style={{ backgroundImage: `url(${heroBg})` }} />
      <div className={styles.overlay} aria-hidden="true" />

      <div className={styles.content}>
        <h1 className={styles.title}>
          {HERO.titleLead}
          <span className="text-gradient">{HERO.titleAccent}</span>
          {HERO.titleTail}
        </h1>
        <p className={styles.subtitle}>{HERO.subtitle}</p>
        <div className={styles.cta}>
          <a href={HERO.ctaHref} className="btn btn-primary">
            {HERO.ctaLabel}
          </a>
        </div>
      </div>
    </section>
  );
}
